module.exports = __webpack_public_path__ + "static/img/speed-three.13881788.jpg";